import React from "react";

import ContentBlock from "../../components/ContentBlock";
import Layout from "../../components/layout/Layout";

import styles from "./findEventsPage.scss";

import CardSlider from "../../components/search/cardSlider/CardSlider";
import FindEventsBanner from "./findEventsBanner/FindEventsBanner";
import TopCategories from "./topCategories/TopCategories";

const boat = require("../../assets/placeholders/image_boat.jpg");
const camera = require("../../assets/placeholders/image_camera.jpg");
const produce = require("../../assets/placeholders/image_produce.jpg");

const ourCards = [
  {
    image: boat,
    title: "Riverboats Music Festival 2019 Music",
    time: "Thu 26th Apr, 9:00 am - 11:00 am",
    location: "St Ives, NSW, Australia",
    priceString: "From Free to $20.00",
    dates: [
      {
        _id: "5b1878235849ac000f9515e8",
        endDate: "1532742668",
        startDate: "1532742668",
        disabled: false,
        display: {
          time: "1:00 pm - 5:00 pm",
          date: "Sat 28th Jul"
        }
      },
      {
        _id: "5b1878235849ac000f9515e8",
        endDate: "1535421068",
        startDate: "1535421068",
        disabled: false,
        display: {
          time: "1:00 pm - 5:00 pm",
          date: "Sat 28th Jul"
        }
      }
    ],
    link: "#"
  },
  {
    image: produce,
    title: "Riverboats Music Festival 2019 Music",
    time: "Thu 26th Apr, 9:00 am - 11:00 am",
    location: "St Ives, NSW, Australia",
    priceString: "From Free to $20.00",
    dates: [
      {
        _id: "5b1878235849ac000f9515e8",
        endDate: "1532742668",
        startDate: "1532742668",
        disabled: false,
        display: {
          time: "1:00 pm - 5:00 pm",
          date: "Sat 28th Jul"
        }
      },
      {
        _id: "5b1878235849ac000f9515e8",
        endDate: "1535421068",
        startDate: "1535421068",
        disabled: false,
        display: {
          time: "1:00 pm - 5:00 pm",
          date: "Sat 28th Jul"
        }
      }
    ],
    link: "#"
  },
  {
    image: camera,
    title: "Riverboats Music Festival 2019 Music",
    time: "Thu 26th Apr, 9:00 am - 11:00 am",
    location: "St Ives, NSW, Australia",
    priceString: "From Free to $20.00",
    dates: [
      {
        _id: "5b1878235849ac000f9515e8",
        endDate: "1532742668",
        startDate: "1532742668",
        disabled: false,
        display: {
          time: "1:00 pm - 5:00 pm",
          date: "Sat 28th Jul"
        }
      },
      {
        _id: "5b1878235849ac000f9515e8",
        endDate: "1535421068",
        startDate: "1535421068",
        disabled: false,
        display: {
          time: "1:00 pm - 5:00 pm",
          date: "Sat 28th Jul"
        }
      }
    ],
    link: "#"
  }
];

const findEventsPage = ({ data }) => {
  return (
    <Layout>
      <FindEventsBanner />

      <div className={styles.events}>
        <CardSlider title="Trending Events" link="#" cards={ourCards} />
        <CardSlider title="This week" link="#" cards={ourCards} />
        <CardSlider title="Free Events" link="#" cards={ourCards} />
      </div>

      <ContentBlock>
        <TopCategories />
      </ContentBlock>
    </Layout>
  );
};

export default findEventsPage;
